/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Works_WithInputs */

const es_home_hero_works_with = /** @type {(inputs: Home_Hero_Works_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta con:`)
};

const en_home_hero_works_with = /** @type {(inputs: Home_Hero_Works_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works with:`)
};

/**
* | output |
* | --- |
* | "Works with:" |
*
* @param {Home_Hero_Works_WithInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_works_with = /** @type {((inputs?: Home_Hero_Works_WithInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Works_WithInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_works_with(inputs)
	return en_home_hero_works_with(inputs)
});
export { home_hero_works_with as "home.hero.works_with" }